export default __webpack_public_path__ + "static/media/mark2.61c67ffb.png";